import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  makeStyles,
  Fade,
  IconButton
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import React, {
  useEffect, useRef, useState,
} from 'react';
import styled from 'styled-components';
import configuration from '../../../../configs/configuration';
import { useLanguage } from '../../../../context/language/language';
import useResponsive from '../../../../utils/responsive';
import {
  DEFAULT_PHONE_NUMBER_LENGTH,
  MY_PHONE_NUMBER_LENGTH,
  validatePhoneNumber,
  validateThaiNumber
} from '../../../../utils/Validator/PhonNumber';
import PhoneTextField from '../../../common/Form/PhoneTextField';
import { InputField, Map, PlacesSearch, Button } from '../../../common';
import useCustomerAddressMethod, {
  ADDRESS_TYPE,
  ADDRESS_UPDATE,
  useAddCustomerAddressMethod,
  useEditCustomerAddressMethod,
} from '../../hook/useCutomerAddressMethod';
import Layout from '../Layout';
import MalaysiaAddressForm from './MalaysiaAddressForm';
import ThailandAddressForm from './ThailandAddressForm';
import PhoneCode from '../../../common/Form/PhoneCode';
import { useSite } from '../../../../context/siteContext';
import { SITES } from '../../../../constant/common/sites';
import { MY_COUNTRY_CODE } from '../../../../utils/constant';
import useDeliveryControlFlow from '../../../common/hook/useDeliveryControlFlow';
import { CUSTOMER_ADDRESS_DISCARD } from '../../../../constant/deliveryFlow';
import { defaultModalSize } from '../modalSize';
import Display from '../../../common/Display';
import RoadWarning from './RoadWarning';
import { trackPageLoad } from '../../../../utils/adobeAnalytics';
import { trackScreen } from '../../../../utils/eventTracking';
import { getImageURL } from '../../../../utils/getImageURL';
import useDeliveryData from '../../../common/hook/useDeliveryData';
import { useUpdateShippingAddress } from '../../../ContractInfo/hook/useContractInfo';
import { setCustomerAddressStep } from '../../../../store/deliveryFlow/slices';

const IconMap = getImageURL('/icon/icon-map.svg');

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    padding: 0,
    minHeight: ({ contentMinHeight }) => contentMinHeight,
    paddingTop: 16,
  },
  containerMapHeight: {
    height: 'auto !important',
    minHeight: ({ contentMinHeight }) => contentMinHeight,
    padding: 'unset',
    paddingTop: 12,
  },
  containerFormHeight: {
    height: 'auto !important',
    padding: 'unset',
    paddingTop: 12,
  },
  btnMap: {
    position: 'relative',
    width: '100%',
    backgroundColor: 'white',
    zIndex: 10,
    paddingTop: theme.isMobile ? 12 : 22,
    paddingBottom: theme.isMobile ? 0 : 24,
  },
  btnForm: {
    backgroundColor: 'white',
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    zIndex: 10,
    paddingTop: theme.isMobile ? 12 : 22,
    paddingBottom: theme.isMobile ? 12 : 22,
    left: 0,
    right: 0,
    margin: 'auto',
    [theme.breakpoints.only('xs')]: {
      paddingLeft: 12,
      paddingRight: 12,
    },
    backgroundColor: 'red',
  },
  space: {
    height: 80,
    width: '100%'
  }
}));

const CheckboxIsdefault = withStyles((theme) => ({
  root: {
    color: theme.custom.colors.grey100,
    '&$checked': {
      color: theme.custom.colors.green600,
    },
  },
  checked: {},
}))((props) => <Checkbox {...props} />);

const Main = styled.div(({ theme, width, maxHeight = '70vh' }) => ({
  width,
  minHeight: theme.isTabletOrMobile ? 'auto' : '100%',
  maxHeight: theme.isTabletOrMobile ? 'calc(100vh - 90px) ' : maxHeight,
  padding: 0,
  '&::-webkit-scrollbar-track': {
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
  },
  '&::-webkit-scrollbar': {
    width: 4,
    backgroundColor: '#FFFFFF',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 4,
    backgroundColor: '#E8E8E8',
  },
}));

const ContainerFormItem = styled.div(({ theme }) => ({
  position: 'relative',
  height: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',
  width: '100%',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar-track': {
    borderRadius: 4,
    backgroundColor: theme.colors.white,
  },
  '&::-webkit-scrollbar': {
    width: 4,
    backgroundColor: theme.colors.white,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.colors.white,
  },
}));

const Content = styled.div(() => ({
  width: '100%',
  margin: 'auto',
}));

const Title = styled.div(() => ({
  overflow: 'hidden',
  width: '100%',
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis',
}));

const Label = styled.div(({ theme }) => ({
  ...theme.fonts.header6,
  color: theme.colors.grey700,
}));
const LabelContent = styled.div(({ theme }) => ({
  ...theme.fonts.testM,
  color: theme.colors.grey550,
}));

const FlexRow = styled(Box)(({ width, margin, justifyContent }) => ({
  display: 'flex',
  flexDirection: 'row',
  width,
  margin,
  justifyContent: justifyContent ?? 'left',
  alignContent: 'center',
}));

const MapContainer = styled.div(({ theme }) => ({
  marginTop: 16,
  borderRadius: 8,
  ...theme.isMobile && {
    marginTop: 12,
  },
}));

const BtnAddressType = styled(Button)(({ theme, active, size }) => ({
  ...theme.radius.m,
  ...theme.fonts.textM,
  marginRight: 8,
  width: 94,
  height: 36,
  textTransform: 'none',
  backgroundColor: active ? theme.colors.green100 : theme.colors.white,
  color: active ? theme.colors.green600 : theme.colors.inactiveToggle,
  border: active
    ? `1px solid ${theme.colors.green600}`
    : `1px solid ${theme.colors.grey100}`,
  padding: '6px 12px 6px 12px',
}));

const BtnCancel = styled(Button)(({ theme }) => ({
  ...theme.radius.m,
  height: 44,
  fontSize: '18px',
  lineHeight: 28 / 18,
  fontWeight: 700,
  marginRight: 8,
  padding: '6px 12px',
  minWidth: theme.isMobile ? 'unset' : 160,
  width: theme.isMobile ? '100%' : 'auto',
  backgroundColor: theme.colors.grey75,
  textTransform: 'none',
}));

const BtnSubmit = styled(Button)(({ theme, disabled }) => ({
  ...theme.radius.m,
  height: 44,
  fontSize: '18px',
  lineHeight: 28 / 18,
  fontWeight: 700,
  padding: '6px 12px',
  minWidth: theme.isMobile ? 'unset' : 160,
  width: theme.isMobile ? '100%' : 'auto',
  textTransform: 'none',
  backgroundColor: disabled ? theme.colors.green100 : theme.colors.green600,
  color: disabled ? theme.colors.grey500 : theme.colors.white,
  '&:hover': {
    backgroundColor: theme.colors.green400,
  },
}));

const PhoneNumberGrid = styled(Grid)(() => ({
  justifyContent: 'space-between'
}));

const Icon = styled.img(({ w = 24, h = 24 }) => ({
  height: w,
  width: h,
}));

const BtnIcon = styled(IconButton)(({
  w = 24, h = 24, ml, mb, mr, flexGrow
}) => ({
  width: w,
  height: h,
  borderRadius: 40,
  padding: '8px 16px 8px 16px',
  backgroundColor: '#F3F3F3',
  display: 'flex'
}));

const initstate = {
  address: '',
  latLng: {
    lat: undefined,
    lng: undefined,
  },
};

function useAction() {
  const {
    action,
    customerId,
    addressId,
    addressDetail,
    setDataAddress,
  } = useCustomerAddressMethod();
  const {
    addIsSuccess, addAddress, resetAddress,
  } = useAddCustomerAddressMethod();
  const {
    editIsSuccess, editAddress, resetEditAddress,
  } = useEditCustomerAddressMethod();
  const [isEdit, setEdit] = useState(true);
  const [values, setValues] = useState({
    ...initstate,
    latLng: {
      lat: addressDetail.latitude || '',
      lng: addressDetail.longitude || '',
    },
  });
  const [initValue, setInitValue] = useState({});
  useEffect(() => {
    setEdit(!_.isEmpty(addressId));
    if (action === 'ADD') {
      trackPageLoad('Add Address');
      trackScreen('profile_add_address');
    } else {
      trackPageLoad('Edit Delivery Address');
      trackScreen('profile_edit_address');
    }
    return () => {
      resetAddress();
      resetEditAddress();
    };
  }, []);

  return {
    action,
    customerId,
    addressId,
    addressDetail,
    setDataAddress,
    addIsSuccess,
    addAddress,
    resetAddress,
    editIsSuccess,
    editAddress,
    resetEditAddress,
    values,
    setValues,
    isEdit,
    setEdit,
    initValue,
    setInitValue,
  };
}

const MAXIMUM_RECIPIENT_NAME_LENGTH = 100;
const MAXIMUM_DELIVERY_NOTE_LENGTH = 250;

function CustomerManageAddress({
  onNext, onBack, onClose, modalRef,
}) {
  const deliveryControl = useDeliveryControlFlow();
  const { isTablet, isMobile } = useResponsive();
  const dispatch = useDispatch();

  const [firstStep, setFirstStep] = useState(true);
  const [step, setStep] = useState(1);
  const [disableConfirmDestination, setDisableConfirmDestination] = useState(false);
  const [mobilePhoneNo, setMobilePhoneNo] = useState('');
  const [canConfirm, setCanConfirm] = useState(false);
  const [countryCode, setCountryCode] = useState('+60');
  const [disableScrollY, setDisableScrollY] = useState(false);
  const [disablePostalCode, setDisablePostalCode] = useState(true);
  const [disableCity, setDisableCity] = useState(true);
  const [disableMyState, setDisableMyState] = useState(true);
  const siteCode = configuration.siteCode;
  const isMY = SITES.MALAYSIA_SITE;
  const isTH = SITES.THAILAND_SITE;
  const { MySite, ThSite } = useSite();
  const word = useLanguage();
  const classes = useStyles({ contentMinHeight: defaultModalSize.mobile.contentMinHeight });
  const deliveryData = useDeliveryData();
  const [errors, setErrors] = useState({
    thSubDistrict: false,
    thDistrict: false,
    thProvince: false,
    myCity: false,
    myState: false,
    mySubDistrict: false,
    postalCode: false
  });

  const {
    action,
    customerId,
    addressId,
    addressDetail,
    setDataAddress,
    addIsSuccess,
    addAddress,
    editIsSuccess,
    editAddress,
    values,
    setValues,
    isEdit,
    setEdit,
    initValue,
    setInitValue,
  } = useAction();
  const {
    updateShipping,
    isSuccess: updateShippingAddressSuccess
  } = useUpdateShippingAddress();

  const [isSearch, setIsSearch] = useState(false);

  const handleSearchPlace = (address) => {
    setValues({ ...values, address });
    setIsSearch(Boolean(address));
  };

  const [phoneValidator, setPhoneValidator] = useState({
    value: false,
    message: '',
  });
  const [otherValidator, setOtherValidator] = useState({
    value: false,
    message: '',
  });

  const [recipientNameValidator, setRecipientNameValidator] = useState({
    value: false,
    message: '',
  });

  const handleSelectPlace = (address, latLng) => {
    setValues({ ...values, address, latLng });
    setIsSearch(false);
    setDisableConfirmDestination(false);
  };

  const onChangeMap = (latLng, address) => {
    deliveryControl.setLoading(false);
    setValues({ ...values, latLng });
    if (isEdit) {
      const placeName = !_.isEmpty(addressDetail.placeName)
        ? addressDetail?.placeName
        : address?.placeName;
      const addressNumber = !_.isEmpty(addressDetail.addressNumber)
        ? addressDetail?.addressNumber
        : address?.addressNumber;
      setDataAddress({
        action,
        addressDetail: {
          ...addressDetail,
          latitude: latLng.lat,
          longitude: latLng.lng,
          placeName,
          addressNumber,
        },
      });
      setInitValue({
        addressId: addressDetail.addressId,
        addressName: addressDetail.addressName,
        addressNumber: addressDetail.addressNumber,
        addressType: addressDetail.addressType,
        contactNo: addressDetail.contactNo,
        // country: addressDetail.country,
        deliveryNote: addressDetail.deliveryNote,
        isDefault: addressDetail.isDefault,
        latitude: addressDetail.latitude,
        longitude: addressDetail.longitude,
        placeName: addressDetail.placeName ?? placeName,
        myCity: address.myCity,
        myDistrict: addressDetail.myDistrict,
        myState: addressDetail.myState,
        mySubDistrict: addressDetail.mySubDistrict,
        postalCode: addressDetail.postalCode,
        recipientName: addressDetail.recipientName,
        thDistrict: address.thDistrict ?? '',
        thMoo: addressDetail.thMoo ?? '',
        thProvince: address.thProvince ?? '',
        thRoad: addressDetail.thRoad ?? '',
        thSoi: addressDetail.thSoi ?? '',
        thSubDistrict: address.thSubDistrict ?? '',
      });
      setCanConfirm(true);
    } else {
      setDataAddress({
        action,
        addressDetail: {
          ...addressDetail,
          latitude: latLng.lat,
          longitude: latLng.lng,
          ...address
        },
      });
      if (firstStep) {
        setInitValue({ 
          ...addressDetail,
          latitude: latLng.lat,
          longitude: latLng.lng,
          ...address
        });
      }
    }
    setFirstStep(false);
    setEdit(false);
    if (!deliveryData?.customerAddressStep) {
      setDisablePostalCode(!!address?.postalCode);
      setDisableCity(!!address?.myCity);
      setDisableMyState(!!address?.myState);
    }
  };
  let sampleText = word('Contact.PhoneNumber.TH.Example');
  if (siteCode === isMY) {
    sampleText = countryCode === '+60' ? word('Contact.PhoneNumber.MY.Example') : word('Contact.PhoneNumber.SG.Example');
  }
  const handleTypeAddress = (type) => {
    setDataAddress({
      action,
      addressDetail: { ...addressDetail, addressName: type },
    });
  };

  const validateList = ["thSubDistrict", "thDistrict", "thProvince", "myCity", "myState", "mySubDistrict", "postalCode"];

  const getValidationName = (name) => {
    let text = '';
    if (name === 'thSubDistrict') {
      text = word(`Address.Empty.SubDistrict`);
    } else if (name === 'thDistrict') {
      text = word('Address.Empty.District');
    } else if (name === 'thProvince') {
      text = word(`Address.Error.Input.Province`);
    } else if (name === 'myCity') {
      text = word(`Address.Error.Input.City`);
    } else if (name === 'myState') {
      text = word(`Address.Error.Input.Province`);
    } else if (name === 'mySubDistrict') {
      text = word(`Address.Error.Input.mySubDistrict`);
    } else if (name === 'postalCode') {
      text = word(`Address.Empty.Postal`);
    }
    return text;
  };

  const handleChangeValue = (e) => {
    if (e?.target?.name === 'contactNo') {
      const re = /^[0-9\b]+$/;
      if (e.target.value === '' || re.test(e.target.value)) {
        setDataAddress({
          action,
          addressDetail: { ...addressDetail, [e.target.name]: e.target.value },
        });
      }
    } else if (e?.target?.name === 'deliveryNote') {
      setDataAddress({
        action,
        addressDetail: {
          ...addressDetail,
          [e?.target?.name]: e?.target?.value
        },
      });
    } else {
      const re = /^[\u0E00-\u0E7Fa-zA-Z0-9-,.()/ ]+$/;
      if (e?.target?.value === '' || re.test(e?.target?.value.trim())) {
        setDataAddress({
          action,
          addressDetail: {
            ...addressDetail,
            [e?.target?.name]: e?.target?.value
          },
        });
        if (validateList?.includes(e?.target?.name)) {
          if (e.target.value === '') {
            setErrors({ ...errors, [e?.target?.name]: getValidationName(e?.target?.name) });
          } else {
            setErrors({ ...errors, [e?.target?.name]: false });
          }
        }
      }
    }

  };

  const setValidate = (name, val) => {
    if (_.isEmpty(val)) {
      setErrors({ ...errors, [name]: false });
    } else {
      setErrors({ ...errors, [name]: val });
    }
  };

  const handleValidate = (address) => {
    let errorsList = {
      addressNumber: "",
      thSubDistrict: "",
      thDistrict: "",
      thProvince: "",
      myCity: "",
      myState: "",
      mySubDistrict: "",
      postalCode: ""
    };
    if (configuration.siteCode === isTH) {
      if (_.isEmpty(address.thSubDistrict)) {
        errorsList.thSubDistrict = word(`Address.Empty.SubDistrict`);
        setErrors({ ...errors, ...errorsList });
      } else {
        setErrors({ ...errors, thSubDistrict: false });
      }

      if (_.isEmpty(address.thDistrict)) {
        errorsList.thDistrict = word(`Address.Empty.District`);
        setErrors({ ...errors, ...errorsList });
      } else {
        setErrors({ ...errors, thDistrict: false });
      }

      if (_.isEmpty(address.thProvince)) {
        errorsList.thProvince = word(`Address.Error.Input.Province`);
        setErrors({ ...errors, ...errorsList });
      } else {
        setErrors({ ...errors, thProvince: false });
      }
    }

    if (configuration.siteCode === isMY) {
      if (_.isEmpty(address.mySubDistrict)) {
        errorsList.mySubDistrict = word(`Address.Error.Input.City`);
        setErrors({ ...errors, ...errorsList });
      } else {
        setErrors({ ...errors, mySubDistrict: false });
      }
      
      if (_.isEmpty(address.myCity)) {
        errorsList.myCity = word(`Address.Error.Input.City`);
        setErrors({ ...errors, ...errorsList });
      } else {
        setErrors({ ...errors, myCity: false });
      }

      if (_.isEmpty(address.myState)) {
        errorsList.myState = word(`Address.Error.Input.Province`);
      } else {
        setErrors({ ...errors, myState: false });
      }
    }

    if (_.isEmpty(address.postalCode)) {
      errorsList.postalCode = word(`Address.Empty.Postal`);
    } else {
      setErrors({ ...errors, postalCode: false });
    }

    setErrors({ ...errors, ...errorsList });
    
  };

  const handleChangeDefault = (e) => {
    setDataAddress({
      action,
      addressDetail: { ...addressDetail, [e.target.name]: e.target.checked },
    });
  };

  const isDisableConfirmBtn = () => {
    if (addressDetail.addressName === '') {
      return true;
    }
    if (configuration.siteCode === isTH) {
      const isDisable = _.isEmpty(addressDetail.thSubDistrict)
        || _.isEmpty(addressDetail.addressNumber)
        || _.isEmpty(addressDetail.recipientName)
        || _.isEmpty(addressDetail.thDistrict)
        || _.isEmpty(addressDetail.thProvince)
        || _.isEmpty(addressDetail.postalCode)
        || _.isEmpty(addressDetail.contactNo)
        || !canConfirm;
      return isDisable;
    }
    if (configuration.siteCode === isMY) {
      const isDisable = _.isEmpty(addressDetail.addressNumber)
        || _.isEmpty(addressDetail.recipientName)
        || _.isEmpty(addressDetail.contactNo)
        || _.isEmpty(addressDetail.mySubDistrict)
        || _.isEmpty(addressDetail.myCity)
        || _.isEmpty(addressDetail.myState)
        || _.isEmpty(addressDetail.postalCode)
        || _.isEmpty(addressDetail.contactNo)
        || !canConfirm;
      return isDisable;
    }
  };

  const handleSummit = () => {
    if (isDisableConfirmBtn()) {
      const elementContainer = document.getElementById('from-scroll-content');
      if (_.isEmpty(addressDetail.recipientName)) {
        setRecipientNameValidator({ value: true, message: '' });
        const elementDom = document.getElementsByName('recipientName');
        if (elementContainer && elementDom.length) {
          const rect = elementDom[0].getBoundingClientRect();
          const y = elementDom[0].offsetTop - rect.height;
          elementContainer.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
      if (_.isEmpty(addressDetail.contactNo)) {
        setPhoneValidator({
          value: true,
          message: word('Mobile.Validation.Format.Error'),
        });
        const elementDom = document.getElementsByName('mobile-number');
        if (elementContainer && elementDom.length) {
          const rect = elementDom[0].getBoundingClientRect();
          const y = elementDom[0].offsetTop - rect.height;
          elementContainer.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
      handleValidate(addressDetail);
      return;
    }

    const data = {
      ...addressDetail,
      name: addressDetail.recipientName,
      addressType: 'delivery',
      thMoo: '',
      thSoi: '',
      thRoad: '',
    };
    if (configuration.siteCode === isTH) {
      delete data.myCity;
      delete data.myState;
      delete data.mySubDistrict;
      delete data.myDistrict;
      data.contactNo = `${countryCode}${mobilePhoneNo.slice(1)}`.replace('+', '');
    }
    if (configuration.siteCode === isMY) {
      data.thMoo = '';
      data.thSoi = '';
      data.thRoad = '';
      data.thDistrict = '';
      data.thSubDistrict = '';
      data.thProvince = '';
      data.contactNo = `${countryCode}${mobilePhoneNo}`.replace('+', '');
      if (_.isEmpty(data.country)) {
        data.country = 'Malaysia';
      }
    }
    if (action === ADDRESS_UPDATE) {
      updateShipping({ ...data, saveAddress: true });
    }
    if (action !== ADDRESS_UPDATE) {
      if (addressId) {
        editAddress(customerId, addressId, data);
      } else {
        addAddress(customerId, data);
      }
    }
  };

  const formChange = (name, setFn, value) => {
    let newValue = value;
    let isCanPreform;
    const mobileMobileValidateLength = DEFAULT_PHONE_NUMBER_LENGTH;
    setPhoneValidator({
      value: false,
      message: '',
    });
    if (siteCode === isMY) {
      isCanPreform = validatePhoneNumber(value, countryCode, siteCode);
    } else {
      if (value.length === mobileMobileValidateLength) {
        isCanPreform = validateThaiNumber(value);
      }
    }

    if (setFn instanceof Function) {
      setFn(newValue);
    }
    handleChangeValue(value);
    setCanConfirm(isCanPreform);
  };
  const verifySubmit = (mobilePhoneNo, sendProps = null, callFn = null) => {
    let shouldCallFn = true;
    let validateResult;
    if (configuration.siteCode === isMY) {
      validateResult = validatePhoneNumber(
        mobilePhoneNo,
        countryCode,
        configuration.siteCode,
      );
    } else {
      validateResult = validateThaiNumber(mobilePhoneNo);
    }
    if (!validateResult) {
      if (mobilePhoneNo === '') {
        setPhoneValidator({
          value: !validateResult,
          message: word('Contact.Error.InvalidMobileNumber'),
        });
      } else {
        setPhoneValidator({
          value: !validateResult,
          message: word('Mobile.Validation.Format.Error'),
        });
      }
      shouldCallFn = false;
    } else {
      setPhoneValidator({
        value: !validateResult,
        message: '',
      });
      setDataAddress({
        action,
        addressDetail: { ...addressDetail, contactNo: mobilePhoneNo },
      });
    }

    if (shouldCallFn && callFn instanceof Function) {
      callFn(sendProps);
    }
  };
  
  const onBlur = () => {
    verifySubmit(mobilePhoneNo);
  };

  const onFocus = () => {
    setPhoneValidator({
      value: false,
      message: '',
    });
  };

  const onAddressTypeFocus = () => {
    setOtherValidator({
      value: false,
      message: '',
    });
  };
  
  const onAddressTypeBlur = () => {
    if (!addressDetail.addressName) {
      setOtherValidator({
        value: true,
        message: '',
      });
    }
  };

  const onPhoneNumberChange = (e) => {
    setMobilePhoneNo(e);
    handleChangeValue(e);
    formChange('phoneNumber', setMobilePhoneNo, e);
    if (e.length === DEFAULT_PHONE_NUMBER_LENGTH) {
      verifySubmit(e);
    }
  };

  const handleCountryCodeChange = (changeValue) => {
    setMobilePhoneNo('');
    formChange('phoneNumber', setMobilePhoneNo, '');
    setPhoneValidator({
      value: false,
      message: '',
    });
    setCountryCode(changeValue);
  };

  const handleDiscardPopup = (btnType = 'back') => {
    const mapBack = sessionStorage.getItem('addressback');
    if (step === 2 && btnType === 'back') {
      if (deliveryData?.customerAddressStep) {
        setStep(deliveryData?.customerAddressStep);
      } else {
        setStep(step - 1);
      }
      return;
    } 
    if (mapBack && btnType === 'back') {
      sessionStorage.removeItem('addressback');
      setStep(2);
      return;
    }

    const values = { ...addressDetail };
    const initData = { ...initValue };
    if (configuration.siteCode === isTH) {
      delete values.myCity;
      delete values.myState;
      delete values.mySubDistrict;
      delete values.myDistrict;
      delete values.country;
      delete values.thMoo;
      delete values.thRoad;
      delete values.thSoi;
      delete values.undefined;
      delete values.longAddress;
      values.contactNo = `${countryCode}${mobilePhoneNo.slice(1)}`.replace('+', '');

      delete initData.myCity;
      delete initData.myState;
      delete initData.mySubDistrict;
      delete initData.myDistrict;
      delete initData.country;
      delete initData.thMoo;
      delete initData.thRoad;
      delete initData.thSoi;
      delete initData.undefined;
      initData.contactNo = `${countryCode}${mobilePhoneNo.slice(1)}`.replace('+', '');
    }
    if (configuration.siteCode === isMY) {
      delete values.thMoo;
      delete values.thSoi;
      delete values.thRoad;
      delete values.thDistrict;
      delete values.thSubDistrict;
      delete values.thProvince;
      delete values.country;
      delete values.undefined;
      delete values.longAddress;
      values.myCity = _.lowerCase(values?.myCity);
      values.myDistrict = _.lowerCase(values?.myDistrict);
      values.myState = _.lowerCase(values?.myState);
      values.contactNo = `${countryCode}${mobilePhoneNo}`.replace('+', '');

      delete initData.thMoo;
      delete initData.thSoi;
      delete initData.thRoad;
      delete initData.thDistrict;
      delete initData.thSubDistrict;
      delete initData.thProvince;
      delete initData.country;
      delete initData.undefined;
      initData.myCity = _.lowerCase(initData?.myCity);
      initData.myDistrict = _.lowerCase(initData?.myDistrict);
      initData.myState = _.lowerCase(initData?.myState);
      initData.contactNo = `${countryCode}${mobilePhoneNo}`.replace('+', '');
    }
    const isSame = _.isEqual(values, initData);
    if (!isSame) {
      sessionStorage.setItem('addressEdits23p', step);
      setDataAddress({
        action,
        addressDetail: {
          ...addressDetail,
          isDiscard: true
        },
      });
      if (deliveryData?.customerAddressStep) {
        setStep(deliveryData?.customerAddressStep);
        sessionStorage.removeItem('addressback');
      }
    }
    return isSame ? onBack() : onNext({ data: '', page: CUSTOMER_ADDRESS_DISCARD });
  };

  const setCordsMap = (lat, lng) => {
    setValues({
      ...values,
      latLng: { lat, lng }
    });
    setDataAddress({
      action,
      addressDetail: {
        ...addressDetail,
        latitude: lat,
        longitude: lng,
      },
    });
  };

  const handlerPermissionChange = (event) => {
    deliveryControl.setLoading(false);
    if (event.currentTarget.state === 'denied') {
      setDisableConfirmDestination(action === 'ADD' ? true : false);
      setCordsMap(ThSite ? 13.745713 : 3.1386299225989105, ThSite ? 100.5336414 : 101.68574698006697);
    }
  };

  React.useEffect(() => {
    const stp = Number(sessionStorage.getItem('addressEdits23p')) || 1;
    setStep(stp);
  }, []);

  React.useEffect(() => {
    if (deliveryData?.customerAddressStep) {
      const mapBack = sessionStorage.getItem('addressback');
      handleValidate(addressDetail);
      if (_.isEmpty(mapBack)) {
        setStep(deliveryData?.customerAddressStep);
      }
      setDisableCity(false);
      setDisableMyState(false);
      setDisablePostalCode(false);
    }
  }, [deliveryData?.customerAddressStep, addressDetail]);

  React.useEffect(() => {
    if (step === 2) {
      if (isMobile) {
        if (window.innerHeight < 606) {
          document.getElementById('modal-container')?.setAttribute("style", "height:540px !important;max-height: -webkit-fill-available");
        } else if (window.innerHeight < 932) {
          document.getElementById('modal-container')?.setAttribute("style", "height:600px !important;max-height: -webkit-fill-available");
        } else {
          document.getElementById('modal-container')?.setAttribute("style", "height:812px !important;max-height: -webkit-fill-available");
        }
      } else {
        document.getElementById('modal-container')?.setAttribute("style", "height:95vh !important;max-height: 100vh");
      }
    } else {
      if (isMobile) {
        document.getElementById('modal-container')?.setAttribute("style", "height:100%; max-height:-webkit-fill-available");
      } else {
        document.getElementById('modal-container')?.setAttribute("style", "height:100%; max-height:calc(100vh * 78 / 100)");
      }
    }
  }, [step]);

  React.useEffect(() => {
    if (addIsSuccess || editIsSuccess || updateShippingAddressSuccess) {
      onBack();
    }
  }, [addIsSuccess, editIsSuccess || updateShippingAddressSuccess]);

  React.useEffect(() => {
    setCountryCode('+60');
    if (navigator.geolocation && navigator.permissions) {
      deliveryControl.setLoading(true);
      navigator.permissions.query({ name: 'geolocation' })
        .then((result) => {
          if (result.state === 'denied' || (navigator.userAgent.indexOf('Firefox') !== -1)) {
            deliveryControl.setLoading(false);
            setDisableConfirmDestination(action === 'ADD' ? true : false);
            setCordsMap(ThSite ? 13.745713 : 3.1386299225989105, ThSite ? 100.5336414 : 101.68574698006697);
          }
          result.onchange = handlerPermissionChange;
        });
    } else {
      if (navigator.userAgent.indexOf('Safari') !== -1) {
        navigator.geolocation.getCurrentPosition((result) => {
          const { coords } = result;
          setCordsMap(coords.latitude, coords.longitude);
        }, (error) => {
          deliveryControl.setLoading(false);
          setDisableConfirmDestination(action === 'ADD' ? true : false);
          setCordsMap(ThSite ? 13.745713 : 3.1386299225989105, ThSite ? 100.5336414 : 101.68574698006697);
        }, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        });
      } else {
        setDisableConfirmDestination(action === 'ADD' ? true : false);
        setCordsMap(ThSite ? 13.745713 : 3.1386299225989105, ThSite ? 100.5336414 : 101.68574698006697);
        deliveryControl.setLoading(false);
      }
    }
    return () => deliveryControl.setLoading(false);
  }, []);

  React.useEffect(() => {
    let contactNo = _.get(addressDetail, 'contactNo', '');
    if (contactNo) {
      contactNo = contactNo.replace('+', '');
    }

    if (MySite) {
      if (contactNo?.startsWith('60') || contactNo?.startsWith('65')) {
        const cc = contactNo.substring(0, 2);
        setCountryCode(`+${cc}`);
        setMobilePhoneNo(contactNo.slice(2));
      } else {
        setMobilePhoneNo(contactNo);
      }
    } else {
      setCountryCode('+66');
      if (contactNo?.startsWith('66')) {
        setMobilePhoneNo(`0${contactNo.slice(2)}`);
      } else {
        setMobilePhoneNo(contactNo);
      }
    }
  }, [addressDetail.contactNo]);

  const contentContainerRef = useRef(null);

  const handlerSearchError = (status) => {
    setDisableScrollY(Boolean(status));
  };

  React.useEffect(() => {
    if (isSearch) {
      setDisableScrollY(false);
    }
  }, [isSearch]);

  const getInfoAddress = () => {
    if (step === 1) {
      return word('DeliveryAddress.Maps.Message');
    }
    return word('DeliveryAddress.TextBox.Message');
  };

  const getClassName = () => {
    if (isMobile) {
      if (step === 1) {
        return classes.containerMapHeight;
      }
      return classes.containerFormHeight;
    }
    if (isTablet) {
      return classes.contentContainer;
    }
    if (step === 1) {
      return classes.contentContainer;
    }
    return classes.contentContainer;
  };

  const getContainerHeight = (h) => {
    return 'unset';
  };

  const getHeight = () => {
    if (step === 2) {
      if (window.innerHeight < 1080) {
        return '656px';
      }
      return '906px';
    }
    return '100%';
  };

  const getHeightSize = () => {
    if (window.innerHeight < 1080) {
      return `${656 - 180}px`;
    }
    return `${906 - 180}px`;
  };

  const getHeightSizeMobile = () => {
    if (window.innerHeight < 606) {
      return '360px';
    }
    if (window.innerHeight < 932) {
      return '440px';
    }
    return '656px';
  };

  const getMapHeightWithMobileSize = () => {
    if (window.innerHeight < 606) {
      return 275;
    }
    return 320;
  };

  return (
    <>
      <Layout
        title={
          action === 'ADD' ? (
            <Title>{word('Address.Add')}</Title>
          ) : (
            <Title>{word('Address.Edit')}</Title>
          )
        }
        onBack={() => { 
          handleDiscardPopup('back');  
          if (deliveryData.customerAddressStep === 2) { 
            dispatch(setCustomerAddressStep(2));
            if (step === 2) {
              handleDiscardPopup('close');  
            }
          }
        }}
        backButtonShown
        onClose={() => {
          if (isMobile) {
            document.getElementById('modal-container')?.setAttribute("style", "height:100%; max-height:-webkit-fill-available");
          } else {
            document.getElementById('modal-container')?.setAttribute("style", "height:100%; max-height:calc(100vh * 78 / 100)");
          }
          handleDiscardPopup('close');
          if (deliveryData.customerAddressStep === 2) { 
            dispatch(setCustomerAddressStep(2));
          }
        }}
        width={isTablet ? defaultModalSize.tablet.width : defaultModalSize.desktop.width}
        height={getHeight()}
        scrollY={!disableScrollY}
        containerId="address-container"
        infoAddress={getInfoAddress()}
        paddingTop={0}
        paddingBottom={0}
        containerHeight={step === 1 ? '100%' : getContainerHeight(304)}
      >
        <Container className={getClassName()} ref={contentContainerRef}>
          <Main maxHeight={'auto'}>
            <Content>
              {(step === 1) && (
                <PlacesSearch
                  value={values.address}
                  onSearch={handleSearchPlace}
                  onSelect={handleSelectPlace}
                  onError={handlerSearchError}
                  floating
                />
              )}
              <Fade in={!isSearch}>
                <div>
                  {!isSearch && (
                    <div id="fade-container">
                      {(step === 1) && (
                        <>
                          <MapContainer>
                            <Map 
                              latLng={values.latLng} 
                              onLocationChange={onChangeMap} 
                              height={isMobile ? getMapHeightWithMobileSize() : 303}
                              onMoveLocation={() => {
                                setDisableConfirmDestination(false);
                              }}
                            />
                          </MapContainer>
                          <FlexRow
                            justifyContent="center"
                            className={classes.btnMap}
                          >
                            <BtnSubmit
                              full
                              id="confirm-destination-address"
                              data-cta-name-en="Confirm Destination"
                              data-cta-name-th="เลือกจุดนี้"
                              data-cta-type="Button"
                              color="secondary"
                              disabled={disableConfirmDestination}
                              onClick={() => setStep(step + 1)}
                            >
                              {word('DeliveryAddress.Maps.Select')}
                            </BtnSubmit>
                          </FlexRow>
                        </>
                      )}
                      {(step === 2) && (
                        <div 
                          id="form-container"
                          style={{ 
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            height: isMobile ? getHeightSizeMobile() : getHeightSize(),
                            position: 'relative',
                            overflow: 'hidden',
                          }} 
                        >
                          <ContainerFormItem id="from-scroll-content">
                            <div id="form-items-content" style={{ height: '100%' }}>
                              <div style={{ paddingBottom: isMobile ? 12 : 16, display: 'flex', justifyContent: 'flex-end' }}>
                                <BtnIcon 
                                  id="map-icon" 
                                  w={90} 
                                  h={36} 
                                  onClick={() => { 
                                    setStep(step - 1);
                                    sessionStorage.setItem('addressback', true);
                                  }}
                                >
                                  <Icon w="20px !important" h={20} src={IconMap} />
                                  <div style={{ fontSize: 14, paddingLeft: 4, color: '#424242' }}>{word('DeliveryAddress.Maps')}</div>
                                </BtnIcon>
                              </div>
                              <FlexRow margin="0px 0px 4px 0px">
                                <Label>{word('Contact.AddressType')}</Label>
                              </FlexRow>
                              <FlexRow>
                                <BtnAddressType
                                  id="address-home-quick"
                                  data-cta-name-en="Address Home Quick"
                                  data-cta-name-th="ที่อยู่บ้านด่วน"
                                  data-cta-type="Button"
                                  size="small"
                                  active={ADDRESS_TYPE.HOME === addressDetail.addressName}
                                  onClick={() => handleTypeAddress(ADDRESS_TYPE.HOME)}
                                >
                                  {word('Contact.AddressType.Home')}
                                </BtnAddressType>
                                <BtnAddressType
                                  id="address-office-quick"
                                  data-cta-name-en="Address Office Quick"
                                  data-cta-name-th="ที่อยู่สำนักงานด่วน"
                                  active={ADDRESS_TYPE.OFFICE === addressDetail.addressName}
                                  onClick={() => handleTypeAddress(ADDRESS_TYPE.OFFICE)}
                                >
                                  {word('Contact.AddressType.Work')}
                                </BtnAddressType>
                                <BtnAddressType
                                  id="address-other-quick"
                                  data-cta-name-en="Address Other Quick"
                                  data-cta-name-th="ที่อยู่อื่นๆ Quick"
                                  active={ADDRESS_TYPE.HOME !== addressDetail.addressName && ADDRESS_TYPE.OFFICE !== addressDetail.addressName}
                                  onClick={() => handleTypeAddress(ADDRESS_TYPE.OTHERS)}
                                >
                                  {word('Contact.AddressType.Other')}
                                </BtnAddressType>
                              </FlexRow>
                              <FlexRow>
                                {ADDRESS_TYPE.HOME !== addressDetail.addressName && ADDRESS_TYPE.OFFICE !== addressDetail.addressName && (
                                  <InputField
                                    label={word('Contact.AddressType.Other.Placeholder')}
                                    name="addressName"
                                    value={addressDetail.addressName}
                                    onChange={handleChangeValue}
                                    onBlur={onAddressTypeBlur}
                                    onFocus={onAddressTypeFocus}
                                    error={otherValidator.value}
                                    fullWidth
                                    inputProps={{ maxLength: 50 }}
                                    size="small"
                                    style={{ marginTop: 10 }}
                                  />
                                )}
                              </FlexRow>
                              <FlexRow mt={2}>
                                <Grid container spacing={2}>
                                  {configuration.siteCode === isTH && (
                                    <ThailandAddressForm
                                      disablePostalCode={disablePostalCode}
                                      addressDetail={addressDetail}
                                      handleChangeValue={handleChangeValue}
                                      errors={errors}
                                    />
                                  )}
                                  {configuration.siteCode === isMY && (
                                    <MalaysiaAddressForm
                                      disablePostalCode={disablePostalCode}
                                      addressDetail={addressDetail}
                                      handleChangeValue={handleChangeValue}
                                      disableCity={disableCity}
                                      disableState={disableMyState}
                                      errors={errors}
                                    />
                                  )}
                                  <Grid item xs={12}>
                                    <LabelContent>
                                      {word('Address.Helptext')}
                                    </LabelContent>
                                  </Grid>
                                  <Grid item md={6} xs={12}>
                                    <InputField
                                      label={word('Contact.Recipient.Name')}
                                      name="recipientName"
                                      value={addressDetail.recipientName}
                                      error={recipientNameValidator.value}
                                      onChange={handleChangeValue}
                                      onFocus={() => {
                                        setRecipientNameValidator({ value: false, message: '' });
                                      }}
                                      onBlur={(e) => {
                                        if (!e?.target.value) {
                                          setRecipientNameValidator({ value: true, message: '' });
                                        }
                                      }}
                                      fullWidth
                                      inputProps={{ maxLength: MAXIMUM_RECIPIENT_NAME_LENGTH }}
                                    />
                                  </Grid>
                                  <PhoneNumberGrid item md={6} xs={12} container>
                                    {siteCode === isMY && (
                                      <Grid item xs={4}>
                                        <PhoneCode
                                          defaultValue={countryCode}
                                          onChange={handleCountryCodeChange}
                                        />
                                      </Grid>
                                    )}
                                    <Grid item xs={siteCode === isMY ? 7 : 12}>
                                      <PhoneTextField
                                        value={mobilePhoneNo}
                                        maxLength={
                                          siteCode === isMY && countryCode === `+${MY_COUNTRY_CODE}`
                                            ? MY_PHONE_NUMBER_LENGTH
                                            : DEFAULT_PHONE_NUMBER_LENGTH
                                        }
                                        onChange={onPhoneNumberChange}
                                        // onClear={onClear}
                                        onClear={() =>
                                          formChange('phoneNumber', setMobilePhoneNo, '')}
                                        onBlur={onBlur}
                                        onFocus={onFocus}
                                        error={phoneValidator.value}
                                        errorMessage={phoneValidator.message}
                                        required
                                        sampleText={sampleText}

                                      />
                                    </Grid>
                                  </PhoneNumberGrid>
                                  <Grid item xs={12}>
                                    <InputField
                                      label={word('Address.Delivery.Note')}
                                      name="deliveryNote"
                                      value={addressDetail.deliveryNote}
                                      onChange={handleChangeValue}
                                      inputProps={{ maxLength: MAXIMUM_DELIVERY_NOTE_LENGTH }}
                                      multiline
                                      rows={3}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12}>
                                    <FormControlLabel
                                      control={(
                                        <CheckboxIsdefault
                                          name="isDefault"
                                          defaultChecked={addressDetail.isDefault}
                                          onChange={handleChangeDefault}
                                        />
                                      )}
                                      label={<LabelContent>{word('Address.Default.Setting')}</LabelContent>}
                                    />
                                  </Grid>
                                  <Display isMy>
                                    <Grid item xs={12}>
                                      <RoadWarning />
                                    </Grid>
                                  </Display>
                                </Grid>
                              </FlexRow>
                            </div>
                          </ContainerFormItem>
                          <div 
                            id="submit-form-content"
                            style={{
                              width: '100%',
                              position: 'relative',
                              zIndex: 10,
                              paddingTop: isMobile ? 12 : 22,
                              paddingBottom: isMobile ? 12 : 22,
                              left: 0,
                              right: 0,
                              margin: 'auto',
                              backgroundColor: 'white',
                            }}
                          >
                            <Grid item xs={12}>
                              <FlexRow
                                justifyContent="center"
                                pb={isMobile ? 2 : 0}
                                className={classes.btnForm}
                              >
                                <BtnSubmit
                                  id="confirm-address-quick"
                                  data-cta-name-en="Confirm"
                                  data-cta-name-th="ยืนยัน"
                                  data-cta-type="Button"
                                  color="secondary"
                                  onClick={handleSummit}
                                >
                                  {word('General.Confirm')}
                                </BtnSubmit>
                              </FlexRow>
                            </Grid>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </Fade>
            </Content>
          </Main>
        </Container>
      </Layout>
    </>
  );
}

export default CustomerManageAddress;
